export default __webpack_public_path__ + "static/media/smallTable.9a954f5b.svg";